/**
 * Pre-compiled localized messages for NumberInput component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import numberInputMessages_en from "./intl/en";
import numberInputMessages_de from "./intl/de";
import numberInputMessages_es from "./intl/es";
import numberInputMessages_fr from "./intl/fr-FR";
import numberInputMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const numberInputMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(numberInputMessages_en),
  de: normalizeMessages(numberInputMessages_de),
  es: normalizeMessages(numberInputMessages_es),
  "fr-FR": normalizeMessages(numberInputMessages_fr),
  "pt-BR": normalizeMessages(numberInputMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for NumberInput component
 */
export type NumberInputMessageKey = "decrement" | "increment";
